// libs
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
`;

export const Currency = styled.span`
  margin-right: ${({ theme }) => theme.spacing.spacing10};
`;

export const Amount = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.subTitleMedium};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export const OriginalPrice = styled(Amount)`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.textDisabled};
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export const Discount = styled.span`
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.positive};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;
